import { OfmJobStatus } from "../constants/const";

const TERMINAL = new Set<OfmJobStatus>([
  OfmJobStatus.CONCLUIDO,
  OfmJobStatus.FALHA,
  OfmJobStatus.CANCELADO,
]);

const RUNNING = new Set<OfmJobStatus>([
  OfmJobStatus.CRIADO,
  OfmJobStatus.AGENDADO,
  OfmJobStatus.EXECUTANDO,
]);

export const isTerminal = (s: OfmJobStatus) => TERMINAL.has(s);
export const isRunning = (s: OfmJobStatus) => RUNNING.has(s);
export const isExecuting = (s: OfmJobStatus) => s === OfmJobStatus.EXECUTANDO;

export function computePollingInterval(rows: { status: OfmJobStatus }[]): number | null {
  if (rows.length === 0) return null;
  if (!rows.some(r => isRunning(r.status))) return null;
  return rows.some(r => isExecuting(r.status)) ? 5_000 : 15_000;
}
export { OfmJobStatus };

